import React from "react";
import Auth from "modules/Auth/Middleware/Auth";
import Layout from "layouts/Layout";
import RaffleAncolContent from "modules/RaffleAncol";
import { setTitle } from "utilities/helper/setTitle";

const RaffleAncolPage: React.FC = () => {
  setTitle("Raffle Ancol");
  return (
    <Auth>
      <Layout>
        <RaffleAncolContent />
      </Layout>
    </Auth>
  );
};

export default RaffleAncolPage;
